// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + "modules-Header" + "." + "7d2f7672fca36dd0bc0d" + ".css";
};